import { createSelector } from 'reselect';

export const selectExtensionDomain = (state) => state.extension;

export const selectExtensionSettings = createSelector(
  selectExtensionDomain,
  (extension) => extension?.settings,
);

export const selectExtensionWebsocketId = createSelector(
  selectExtensionDomain,
  (extension) => extension?.websocketId,
);

export const selectExtensionVersion = createSelector(
  selectExtensionSettings,
  (settings) => settings?.version,
);

export const selectIsExtensionConnected = createSelector(
  selectExtensionSettings,
  (settings) => settings?.isDetected,
);
